/* eslint-disable react/jsx-filename-extension, react/static-property-placement */

import React from 'react';
import PropTypes from 'prop-types';
import DOMPurify from 'dompurify';

/**
 * A React component for an article Media Icon in an article list, and the analog
 * to the PHP template part `img.php`.
 */
export default class ArticleMediaIcon extends React.PureComponent {
  static propTypes = {
    mediaTypeIcon: PropTypes.shape({
      name: PropTypes.string,
      label: PropTypes.string,
    }).isRequired,
  };

  /**
   * Get media icon.
   */
  render() {
    const { mediaTypeIcon } = this.props;
    const svgs = {
      audio: '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="13" viewBox="0 0 15 13"><defs><style>.cls-7{fill:#fff;fill-rule:evenodd}</style></defs><path id="listen_small_carousel_button_default" data-name="listen small carousel button default" class="cls-7" d="M836.992 1121.17a.836.836 0 0 1-.466.76.709.709 0 0 1-.346.08.783.783 0 0 1-.52-.19l-4.463-3.78h-2.37a.818.818 0 0 1-.817-.83l-.01-3.34a.82.82 0 0 1 .811-.84l2.371-.01 4.439-3.82a.786.786 0 0 1 .866-.11.829.829 0 0 1 .47.75l.035 11.33zm4.121-1.32h-.059a.789.789 0 0 1-.576-.24l-.109-.11a.853.853 0 0 1-.082-1.09 4.959 4.959 0 0 0 .922-2.91 4.908 4.908 0 0 0-1.066-3.07.854.854 0 0 1 .052-1.12l.109-.12a.783.783 0 0 1 .615-.24.808.808 0 0 1 .591.3 6.762 6.762 0 0 1 1.479 4.24 6.838 6.838 0 0 1-1.284 4.03.825.825 0 0 1-.592.33z" transform="translate(-828 -1109)"/></svg>',
      default: '<svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 12 12"><defs><style>.cls-4{fill:#000;}</style></defs><circle id="default__bullet__button" data-name="default" class="cls-4" cx="5.5" cy="5.5" r="5.5"/></svg>',
      gallery: '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="12" xmlns:v="https://vecta.io/nano"><defs><style>.cls-5{fill:#fff;fill-rule:evenodd}</style></defs><path d="M4.49.627c-.368 0-.667.298-.667.667h0v1.033h7.846a.8.8 0 0 1 .8.8h0v5.258H13.5c.368 0 .667-.298.667-.667h0V1.294c0-.368-.298-.667-.667-.667h0-9.01zM.833 4.282c0-.368.298-.667.667-.667h0 9.011c.368 0 .667.298.667.667h0v6.425c0 .368-.298.667-.667.667h0H1.5c-.368 0-.667-.298-.667-.667h0V4.282z" class="cls-5" /></svg>',
      livestream: '<svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11"><defs><style>.cls-6{fill:#fff}</style></defs><circle id="live_small_carousel_button_default" data-name="live small carousel button default" class="cls-6" cx="5.5" cy="5.5" r="5.5"/></svg>',
      video: '<svg width="15" height="16" viewBox="0 0 15 16" xmlns="http://www.w3.org/2000/svg"><defs><style>.cls-3{fill:#fff;fill-rule:evenodd}</style></defs><path d="M0 13.6457V2.35094C0 0.99199 1.41453 0.0955065 2.64344 0.675612L13.9382 6.00731C15.3192 6.65918 15.3627 8.60798 14.0123 9.32093L2.71754 15.284C1.48379 15.9354 0 15.0409 0 13.6457Z" class="cls-3"/></svg>',
    };
    const svg = ('object' === typeof mediaTypeIcon && '' !== mediaTypeIcon.name)
      ? svgs[mediaTypeIcon.name]
      : '';

    if (! svg) {
      return null;
    }

    const className = [
      'article-list__article-mediaicon',
      `article-list__article-mediaicon--${mediaTypeIcon.name}`,
    ].join(' ');

    return (
      <span aria-hidden="true" tabIndex="-1" className={className}>
        <span
          className="article-list__article-mediaicon-svg"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ // phpcs:disable WordPressVIPMinimum.JS.DangerouslySetInnerHTML.Found
            __html: DOMPurify.sanitize(svg),
          }}
        />
      </span>
    );
  }
}
